export default {
  headerContent: {
    title: 'Groupama Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Konut Sigortası',
    description: {
      title: 'Groupama Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Gruopama konut sigortası, konutta oluşacak hasarlar sonucunda ortaya çıkan finansal kayıpların önüne geçerek sigortalıya koruma sağlar.',
        'Konut sigortası, yangın, hırsızlık, sel ve su baskını gibi risklere karşı güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Yangın, yıldırım, infilak',
            'Yangın mali mesuliyet',
            'Dahili su',
            'Kar ağırlığı',
            'Duman',
            'Kara taşıtları çarpması',
            'Hava taşıtları çarpması',
            'Deniz taşıtları çarpması',
            'Sel-su baskını',
            'Fırtına',
            'Enkaz kaldırma',
            'GLKHHKNH ve terör',
            'Deprem',
            'Hırsızlık',
            'Cam kırılması teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
